import React from 'react'
import { motion } from 'framer-motion'
import { Shield, Zap, Globe, Star, ArrowRight, Download, Lock } from 'lucide-react'

const VPNPromotion: React.FC = () => {
  const handleVPNClick = () => {
    // 这里替换为您的VPN推广链接
    window.open('https://iosguid.startvpn.xyz', '_blank')
  }

  return (
    <section className="py-16 px-4 bg-gradient-to-br from-purple-50 via-blue-50 to-indigo-50">
      <div className="max-w-4xl mx-auto">
        {/* 主标题区域 */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <div className="flex items-center justify-center space-x-2 mb-4">
            <Shield className="w-8 h-8 text-purple-600" />
            <h2 className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent">
              加速迁移必备工具
            </h2>
          </div>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            使用VPN可以更稳定地访问外区App Store，确保迁移过程顺畅无阻
          </p>
        </motion.div>

        {/* 主要推广卡片 */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
          className="bg-white rounded-3xl shadow-2xl border border-purple-100 overflow-hidden mb-8"
        >
          {/* 顶部横幅 */}
          <div className="bg-gradient-to-r from-purple-600 to-blue-600 text-white p-4 text-center">
            <div className="flex items-center justify-center space-x-2 mb-2">
              <Zap className="w-5 h-5" />
              <span className="font-bold text-lg">限时优惠</span>
            </div>
            <p className="text-sm opacity-90">下载即送VIP体验机会</p>
          </div>

          {/* 主要内容 */}
          <div className="p-6">
            <div className="flex items-center justify-between mb-6">
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-gradient-to-br from-purple-500 to-blue-500 rounded-xl flex items-center justify-center">
                  <Globe className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900">暴风加速器</h3>
                  <div className="flex items-center space-x-1">
                    {[...Array(5)].map((_, i) => (
                      <Star key={i} className="w-4 h-4 text-yellow-400 fill-current" />
                    ))}
                    <span className="text-sm text-gray-500 ml-1">4.9分</span>
                  </div>
                </div>
              </div>
              <div className="text-right">
                <div className="text-2xl font-bold text-purple-600">¥0</div>
                <div className="text-sm text-gray-500 line-through">¥99/月</div>
              </div>
            </div>

            {/* 功能特点 */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
              <div className="flex items-center space-x-2 text-sm text-gray-600">
                <Lock className="w-4 h-4 text-green-500" />
                <span>军事级加密</span>
              </div>
              <div className="flex items-center space-x-2 text-sm text-gray-600">
                <Zap className="w-4 h-4 text-blue-500" />
                <span>极速连接</span>
              </div>
              <div className="flex items-center space-x-2 text-sm text-gray-600">
                <Globe className="w-4 h-4 text-purple-500" />
                <span>全球节点</span>
              </div>
            </div>

            {/* 行动按钮 */}
            <motion.button
              onClick={handleVPNClick}
              className="w-full bg-gradient-to-r from-purple-600 to-blue-600 text-white py-4 px-6 rounded-2xl font-bold text-lg flex items-center justify-center space-x-2 shadow-lg hover:shadow-xl transition-all duration-300"
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              <Download className="w-5 h-5" />
              <span>立即下载 暴风加速器</span>
              <ArrowRight className="w-5 h-5" />
            </motion.button>

            <p className="text-xs text-gray-500 text-center mt-3">
              点击下载即表示同意服务条款和隐私政策
            </p>
          </div>
        </motion.div>

        {/* 为什么需要VPN */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          viewport={{ once: true }}
          className="grid grid-cols-1 md:grid-cols-2 gap-6"
        >
          <div className="bg-white rounded-2xl p-6 border border-gray-200 shadow-lg">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 bg-red-100 rounded-lg flex items-center justify-center">
                <Shield className="w-5 h-5 text-red-600" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900">解决访问问题</h3>
            </div>
            <p className="text-gray-600 text-sm leading-relaxed">
              外区App Store访问不稳定？VPN可以帮您稳定连接，确保迁移过程顺利进行，避免下载中断。
            </p>
          </div>

          <div className="bg-white rounded-2xl p-6 border border-gray-200 shadow-lg">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center">
                <Zap className="w-5 h-5 text-green-600" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900">提升下载速度</h3>
            </div>
            <p className="text-gray-600 text-sm leading-relaxed">
              通过优化网络路由，VPN可以显著提升外区App Store的下载速度，让您更快完成迁移。
            </p>
          </div>
        </motion.div>

        {/* 底部提示 */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          viewport={{ once: true }}
          className="mt-8 text-center"
        >
          <div className="bg-blue-50 border border-blue-200 rounded-2xl p-4">
            <p className="text-sm text-blue-800">
              💡 <strong>小贴士：</strong>建议在开始迁移前先下载并配置VPN，这样可以确保整个迁移过程更加顺畅
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  )
}

export default VPNPromotion
